import React,{useEffect} from "react";
import { TrendingDomainCards } from "../trending-domain-cards";
import { useNavigate } from "react-router-dom";

export const TrendingDomains = () => {
  const navigate = useNavigate();
  useEffect(() => {
    scrollToTop();
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  const handleClick = () => {
    navigate("/alldomains");
  };
  return (
    <div className="px-0 px-lg-2 mx-md-5">
      <div className="d-md-flex justify-content-between mb-4 mb-sm-5">
        <div className="text-start">
          <div className="medium-header">
            Trending <span className="primary-color">programs</span>
          </div>
        </div>
        <div className="my-3 my-sm-4 mt-md-2 text-start me-auto me-md-0">
          <button
            className="bg-transparent text-white border border-white px-4 py-1 primary-btn"
            onClick={handleClick}
          >
            All Programs
          </button>
        </div>
      </div>
      <TrendingDomainCards />
    </div>
  );
};
